<template>
      <div >
        <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
        <br/>
        <div style="padding:10px 0 30px 10px;background: #f7f7f7;">

        </div>
        <div style="overflow: hidden;margin-bottom: 20px;">
          <div id="1" style="height: 400px;width: 40%;float:left;"></div>
          <!--按钮-->
          <el-button  @click="formExport(1)"type="primary" style="float: right">{{$t("analyse.device.export")}}</el-button>

          <div style="height: 400px;width: 60%;float:left;border-right: 1px solid #999">
            <table-page ref="childTable" :pageData="pageData"></table-page>
          </div>
        </div>

        <div style="padding:10px 0 30px 10px;background: #f7f7f7;">

        </div>

        <div style="overflow: hidden;margin-bottom: 20px; ">
          <div id="2" style="height: 400px;width: 40%;float:left;"></div>
          <!--按钮-->
          <el-button  @click="formExport(2)"type="primary" style="float: right">{{$t("analyse.device.export")}}</el-button>
          <div style="height: 400px;width: 60%;float:left;border-right: 1px solid #999">
            <table-page ref="childTable2"  :pageData="pageData2"></table-page>
          </div>
        </div>
        <div style="padding:10px 0 30px 10px;background: #f7f7f7;">

        </div>
        <div style="overflow: hidden;margin-bottom: 20px; ">
          <div id="3" style="height: 400px;width: 40%;float:left;"></div>
          <!--按钮-->
          <el-button  @click="formExport(3)"type="primary" style="float: right">{{$t("analyse.device.export")}}</el-button>
          <div style="height: 400px;width: 60%;float:left;border-right: 1px solid #999">
            <table-page ref="childTable3"  :pageData="pageData3"></table-page>
          </div>
        </div>
        <div style="padding:10px 0 30px 10px;background: #f7f7f7;">

        </div>
        <div style="overflow: hidden;margin-bottom: 20px; ">
          <!--按钮-->
          <el-button  @click="formExport(4)"type="primary" style="float: right">{{$t("analyse.device.export")}}</el-button>
          <div id="4" style="height: 400px;width: 40%;float:left;"></div>
          <div style="height: 400px;width: 60%;float:left;">
            <table-page ref="childTable4"  :pageData="pageData4"></table-page>
          </div>
        </div>



      </div>

</template>

<script>
  //存款平台
  let inChannels={};
  //存款方式
  let payWays={};
  let commentStatus={"0":window.$t("other.public.notAudit"),"1":window.$t("other.public.pass"),"2":window.$t("other.public.noPass")};
  let deviceType={"0":window.$t("analyse.device.enable"),"1":window.$t("analyse.device.landing")}
  let activation={"0":window.$t("analyse.device.beenActivated"),"1":window.$t("analyse.device.notActivated")}
  let channels={};//渠道
  let series={};//系列
  let mjs={};//媒介
    //table封装组件
    import URL from '@/views/analyse/util/url'
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import download from '@/utils/download'
  import Qs from 'qs'
  const Echarts = require('echarts');
    export default {
        name: 'list',
        components: {
            FORM,
            tablePage,
            UPDATE
        },
        created(){
            this.getSeries();
        },
        data() {
            return {
                formData:{
                    cols:[
                        { title: window.$t("analyse.device.startTime"), field: 'startTime',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        { title: window.$t("analyse.device.endTime"), field: 'endTime',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        { title: window.$t('analyse.device.type'), field: 'deviceType',type:2,optionList:deviceType},
                        { title: window.$t('analyse.device.activation'), field: 'activation',type:2,optionList:activation},
                        { title: window.$t('analyse.device.source'), field: 'source',type:2,optionList:channels},
                        { title: window.$t('analyse.device.medium'), field: 'medium',type:2,optionList:mjs},
                        { title: window.$t('analyse.device.series'), field: 'series',type:2,optionList:series},
                        { title: window.$t("analyse.device.account"), field: 'account'},
                        {click:window.$t("common.search"),auth:'analyse:chshinDeposit:sel'}
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.deviceVn.deviceList+"?type=1",
                    selection: false,
                    sequence: false,
                    method:"get",
                    isPage:false,
                    cols: [
                        { title: window.$t("analyse.device.vendor"), field: 'device',render:(data)=>{
                                if(data == "其他"){
                                    return window.$t("analyse.device.other");
                                }else{
                                    return data;
                                }

                            }},
                        { title: window.$t("analyse.device.userCount"), field: 'userCount'},
                        { title: window.$t("analyse.device.userRatio"), field: 'userRatio'},
                        { title: window.$t("analyse.device.accessCount"), field: 'accessCount'},
                        { title: window.$t("analyse.device.accessRatio"), field: 'accessRatio'},
                    ]
                },
                pageData2: {
                    isShow: false,
                    queryUrl: URL.deviceVn.deviceList+"?type=2",
                    selection: false,
                    sequence: false,
                    method:"get",
                    isPage:false,
                    cols: [
                        { title: window.$t("analyse.device.deviceModel"), field: 'device',render:(data)=>{
                                if(data == "其他"){
                                    return window.$t("analyse.device.other");
                                }else{
                                    return data;
                                }

                            }},
                        { title: window.$t("analyse.device.userCount"), field: 'userCount'},
                        { title: window.$t("analyse.device.userRatio"), field: 'userRatio'},
                        { title: window.$t("analyse.device.accessCount"), field: 'accessCount'},
                        { title: window.$t("analyse.device.accessRatio"), field: 'accessRatio'},
                    ]
                },
                pageData3: {
                    isShow: false,
                    queryUrl: URL.deviceVn.deviceList+"?type=3",
                    selection: false,
                    sequence: false,
                    method:"get",
                    isPage:false,
                    cols: [
                        { title: window.$t("analyse.device.platform"), field: 'device',render:(data)=>{
                                if(data == "其他"){
                                    return window.$t("analyse.device.other");
                                }else{
                                    return data;
                                }

                            }},
                        { title: window.$t("analyse.device.userCount"), field: 'userCount'},
                        { title: window.$t("analyse.device.userRatio"), field: 'userRatio'},
                        { title: window.$t("analyse.device.accessCount"), field: 'accessCount'},
                        { title: window.$t("analyse.device.accessRatio"), field: 'accessRatio'},
                    ]
                },
                pageData4: {
                    isShow: false,
                    queryUrl: URL.deviceVn.deviceList+"?type=4",
                    selection: false,
                    sequence: false,
                    method:"get",
                    isPage:false,
                    cols: [
                        { title: window.$t("analyse.device.osVersion"), field: 'device',render:(data)=>{
                                if(data == "其他"){
                                    return window.$t("analyse.device.other");
                                }else{
                                    return data;
                                }

                            }},
                        { title: window.$t("analyse.device.userCount"), field: 'userCount'},
                        { title: window.$t("analyse.device.userRatio"), field: 'userRatio'},
                        { title: window.$t("analyse.device.accessCount"), field: 'accessCount'},
                        { title: window.$t("analyse.device.accessRatio"), field: 'accessRatio'},
                    ]
                },

            }
        },
        mounted(){
            this.init("");
            this.$refs.childTable.defaultGetData();
            this.$refs.childTable2.defaultGetData();
            this.$refs.childTable3.defaultGetData();
            this.$refs.childTable4.defaultGetData();
        },
        methods: {
            formExport(type){
                let data = this.$refs.childForm.getQueryData();
                let result="";
                if(data != null && data != ''){
                    for (let name in data) {
                        if (typeof data[name] != 'function') {
                            result += "&" + name + "=" + encodeURI(data[name]);
                        }
                    }
                }
                let name = window.$t("analyse.device.vendor");
                if(type == 2){
                    name = window.$t("analyse.device.deviceModel");
                }else if(type == 3){
                    name = window.$t("analyse.device.platform");
                }else if(type == 4){
                    name = window.$t("analyse.device.osVersion");
                }else{
                    name = window.$t("analyse.device.vendor");
                }
                download.exportExcel(URL.deviceVn.download+"?type="+type+result, {}, name);
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(clickName == "查询" || window.$t("common.search") == clickName){
                    this.queryData = data;
                    if(data != null && data != ''){
                        let result="";
                        for (let name in data) {
                            if (typeof data[name] != 'function') {
                                result += "&" + name + "=" + encodeURI(data[name]);
                            }
                        }
                        this.init(result);
                    }
                    this.$refs.childTable.defaultQueryData(data);
                    this.$refs.childTable2.defaultQueryData(data);
                    this.$refs.childTable3.defaultQueryData(data);
                    this.$refs.childTable4.defaultQueryData(data);

                }
            },
            getSeries(){
                this.$axios.get(URL.accountAnalyseVn.getData).then(res => {
                    if (res.code == 0) {
                        let source=JSON.parse(JSON.stringify(res.result.channels));
                        let medium=JSON.parse(JSON.stringify(res.result.mjs));
                        let series=JSON.parse(JSON.stringify(res.result.series));
                        for (const i in source){
                            source[i].value=source[i].value;
                            source[i].key=source[i].key
                        }
                        for (const i in medium){
                            medium[i].value=medium[i].value;
                            medium[i].key=medium[i].key
                        }
                        for (const i in series){
                            series[i].value=series[i].value;
                            series[i].key=series[i].key
                        }
                        for (const i in this.formData.cols){
                            if (this.formData.cols[i].field=="source"){
                                this.formData.cols[i].optionList=source
                            }
                            if (this.formData.cols[i].field=="medium"){
                                this.formData.cols[i].optionList=medium
                            }
                            if (this.formData.cols[i].field=="series"){
                                this.formData.cols[i].optionList=series
                            }
                        }
                    }
                });
            },
            init(data){
                this.$axios.get(URL.deviceVn.vendor + "?type=1"+data).then(res => {
                    if(res.code == 0){
                        let data=[],arr=[];
                        if (res.result&&res.result.length>0){
                            for (const i in res.result){
                                data.push({value:res.result[i].userCount, name:"其他"==res.result[i].device?window.$t("analyse.device.other"):res.result[i].device});
                                arr.push(res.result[i].device);
                            }
                        }
                        //渲染图一
                        this.setOption("1", window.$t("analyse.device.deviceVendor"),data,arr);
                    }
                });
                this.$axios.get(URL.deviceVn.vendor + "?type=2"+data).then(res => {
                    if(res.code == 0){
                        let data=[],arr=[];
                        if (res.result&&res.result.length>0){
                            for (const i in res.result){
                                data.push({value:res.result[i].userCount, name:"其他"==res.result[i].device?window.$t("analyse.device.other"):res.result[i].device});
                                arr.push(res.result[i].device);
                            }
                        }
                        //渲染图一
                        this.setOption("2", window.$t("analyse.device.model"),data,arr);
                    }
                });

                this.$axios.get(URL.deviceVn.vendor + "?type=3"+data).then(res => {
                    if(res.code == 0){
                        let data=[],arr=[];
                        if (res.result&&res.result.length>0){
                            for (const i in res.result){
                                data.push({value:res.result[i].userCount, name:"其他"==res.result[i].device?window.$t("analyse.device.other"):res.result[i].device});
                                arr.push(res.result[i].device);
                            }
                        }
                        //渲染图一
                        this.setOption("3",window.$t("analyse.device.form"),data,arr);
                    }
                });
                this.$axios.get(URL.deviceVn.vendor + "?type=4"+data).then(res => {
                    if(res.code == 0){
                        let data=[],arr=[];
                        if (res.result&&res.result.length>0){
                            for (const i in res.result){
                                data.push({value:res.result[i].userCount, name:"其他"==res.result[i].device?window.$t("analyse.device.other"):res.result[i].device});
                                arr.push(res.result[i].device);
                            }
                        }
                        //渲染图一
                        this.setOption("4",window.$t("analyse.device.version"),data,arr);
                    }
                });
            },
            /*渲染图一，饼状图*/
            setOption(id,title,datas,arr){
                Echarts.init(document.getElementById(id)).setOption({
                    title : {
                        text: title,
                        x:'left'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "<br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        top:"30",
                        orient: 'horizontal',
                        left: 'left',
                        data: arr
                    },
                    series : [
                        {
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            //显示数据和数据所占比例
                            label: {
                                normal: {
                                    show: true,
                                    formatter: '{b}: {c}({d}%)',
                                    color:"#000000"
                                }
                            },
                            data:datas
                        }
                    ]
                });
            },

        }
    }
</script>
